import React from 'react';

export default function ScoreIndicator({ value, variant }) {
  let parsedValue = parseFloat(value);

  return (
    <div data-component-name='ScoreIndicator'>
      <div
        className={`${
          parsedValue > 0
            ? `${
                variant === 'small' ? '' : 'bg-white-400'
              } text-green-400 border-green-400`
            : ''
        } ${
          parsedValue < 0
            ? ` ${variant === 'small' ? '' : 'bg-white-400'} text-red-400 border-red-200`
            : ''
        } ${parsedValue === 0 ? ' text-blue-300 border-blue-300' : ''} rounded-full ${
          variant === 'small'
            ? 'text-xs'
            : 'h-6 px-2 text-sm border min-w-[40px] max-w-[40px]'
        } font-bold flex items-center justify-center`}
      >
        {(parsedValue > 0 || parsedValue === 0) && <span>+</span>}
        {value}
      </div>
    </div>
  );
}
